<template>
  <div class="flex flex-col lg:flex-row find-course-container">
    <div
      class="h-full w-full lg:w-1/4 th-card shadow-box box-filter mb-8 lg:mb-0 lg:mr-8"
    >
      <DropdownFilter class="padding-x-content" title="Cari di Kategori Ini">
        <div style="margin-top: 20px" class="flex w-full">
          <!-- <va-input
            class="search-input"
            style="width: 80%"
            v-model="filter.search"
          />
          <div
            @click.prevent="onSearch"
            class="search-click th-hover-pointer th-hover-bg-primary"
            style="width: 20%"
          >
            <search-icon
              style="margin: auto; width: 100%"
              :width="16"
              :height="16"
              :iconColor="'#ffffff'"
            />
          </div> -->
          <va-select
            class="th-button-select-group"
            multiple
            :options="categoryOptions"
            placeholder="Cari berdasarkan kategori"
            v-model="filter.category"
          ></va-select>
        </div>
      </DropdownFilter>
      <hr style="margin-top: 20px; margin-bottom: 20px" />
      <DropdownFilter class="padding-x-content" title="Jenis Course">
        <div style="margin-top: 14px">
          <va-checkbox-group
            v-model="filter.type"
            :vertical="true"
          >
            <va-checkbox
              v-for="type in courseType"
              :key="type.value"
              :label="type.value"
              >{{ type.label }}</va-checkbox
            >
          </va-checkbox-group>
        </div>
      </DropdownFilter>
      <hr style="margin-top: 20px; margin-bottom: 20px" />
      <DropdownFilter class="padding-x-content" title="Ulasan">
        <div style="margin-top: 14px">
          <va-checkbox-group
            @change="onChangeRating"
            v-model="filter.starRating"
            :vertical="true"
          >
            <va-checkbox v-for="n in 5" :key="6 - n" :label="6 - n">
              <star-rating
                :rating="6 - n"
                :star-size="20"
                :show-rating="false"
                :rounded-corners="true"
                read-only
              />
            </va-checkbox>
          </va-checkbox-group>
        </div>
      </DropdownFilter>
    </div>
    <div class="h-full w-full lg:w-3/4">
      <div>
        <div
          class="flex flex-col lg:flex-row w-full justify-center lg:justify-between th-font-gray-3 items-center mb-8"
        >
          <p>Menampilkan {{ totalShownCourse }} Course(s)</p>
          <div class="flex items-center mt-4 lg:mt-0">
            <div>
              <p class="whitespace-nowrap">Urutkan Berdasarkan:</p>
            </div>
            <va-select
              no-uncheck
              style="margin-left: 10px"
              class="th-select-subtle th-btn-sort"
              @change="onChangeSort"
              v-model="sortBy"
              :options="sortByDatas"
            />
          </div>
        </div>
        <div class="h-full flex justify-center" v-if="!foundCourseDatas.length">
          Course tidak ditemukan.
        </div>
        <template v-else>
          <va-row :gutter="16">
            <va-column
              style="margin-bottom: 32px"
              :lg="4"
              :xs="12"
              :md="6"
              v-for="course in foundCourseDatas"
              :key="course.key"
            >
              <CardCourse
                :content="course"
                :dataIsWishlist="course.isWishlist"
              />
            </va-column>
          </va-row>
          <va-pagination
            :value="currentPage"
            :total="totalShownCourse"
            :max="5"
            @change="changePage"
            :per-page="limitPerPage"
          ></va-pagination>
        </template>
      </div>
      <hr class="mb-10 mt-5" />
      <div style="margin-top: 30px;">
        <a href="#featured">
          <h3>Course Pilihan</h3>
        </a>
        <TemplateCarousel id="featured" :courses="dataFeaturedCourses" class="arrow-none" :cardType="2" :settings="carouselSetting" style="margin-top: 20px;" />
      </div>
    </div>
  </div>
</template>

<script>
import StarRating from 'vue-star-rating'
const CardCourse = () => import('@/components/Shared/CardCourse/1')
const TemplateCarousel = () => import('@/components/Shared/CardCourse/TemplateCarousel')
const DropdownFilter = () => import('@/components/App/Dropdown/FilterSearch')
// const SearchIcon = () => import('@/components/Icon/Search')

const sortByDatas = [
  { value: 'terbaru', label: 'Terbaru' },
  { value: 'terlama', label: 'Terlama' },
  { value: 'termurah', label: 'Termurah' },
  { value: 'termahal', label: 'Termahal' },
]

const courseType = [
  { value: 'all', label: 'Semua Jenis' },
  { value: 'free', label: 'Gratis' },
  { value: 'popular', label: 'Populer' },
  { value: 'premium', label: 'Berbayar' },
]

const carouselSetting = {
  arrow: false,
  dots: true,
  focusOnSelect: false,
  slidesToShow: 1,
  slideToScroll: 1,
  infinite: true,
  variableWidth: true,
  responsive: [
    {
      breakpoint: 850,
      settings: {
        variableWidth: false,
      },
    },
  ],
}

export default {
  components: {
    CardCourse,
    DropdownFilter,
    // SearchIcon,
    TemplateCarousel,
    StarRating,
  },
  watch: {
    'filter.type' (_, oldVal) {
      this.onChangeType(oldVal)
    },
    'filter.category' (_, oldVal) {
      if (!this.filter.type.includes('all')) this.filter.type = ['all']
      if (!this.filter.starRating.length !== 5) this.filter.starRating = [1, 2, 3, 4, 5]
      this.fetchFoundCourse()
    },
    searchCourse(newVal) {
      // console.log(newVal)
      this.filter.search = newVal
      this.fetchFoundCourse()
    },
  },
  data() {
    return {
      sortBy: 'terbaru',
      sortByDatas,
      foundCourseDatas: [],
      dataFeaturedCourses: [],
      courseType,
      filter: {
        type: [],
        search: null,
        starRating: [1, 2, 3, 4, 5],
        category: [],
      },
      carouselSetting,
      currentPage: 1,
      limitPerPage: 9,
      categoryOptions: [],
      totalCourse: 0,
    }
  },
  methods: {
    changePage(e) {
      // this.fetchFoundCourse()
      this.currentPage = e.pageNumber
      this.fetchFoundCourse()
    },
    onSearch() {
      this.fetchFoundCourse()
    },
    onChangeType(oldVal) {
      // if (model.includes('all') && !this.filter.type.includes('all')) this.filter.type = this.courseType.map(type => type.value)
      // else if (model.includes('all') && this.filter.type.includes('all')) {
      //   this.filter.type = []
      // } else if (model.includes('all') && this.filter.type.includes('all') && model.length !== this.courseType.length) {
      //   this.filter.type = model.filter(type => type !== 'all')
      // } else this.filter.type = model
      const types = this.filter.type
      if (types.includes('all')) {
        if (oldVal.includes('all')) {
          if (types.length !== this.courseType.length) this.filter.type = this.filter.type.filter(type => type !== 'all') // - case 2
        } else if (!oldVal.includes('all')) {
          this.filter.type = this.courseType.map(type => type.value) // kalo sebelumnya gada all dan sekarang ada maka gini -  case 1
        }
      } else if (!types.includes('all')) {
        if (oldVal.includes('all')) {
          // console.log(types, oldVal)
          // if () this.filter.type = []
          if (oldVal.length === this.courseType.length) this.filter.type = []
        } else if (!oldVal.includes('all')) {
          if (types.length === this.courseType.length - 1) this.filter.type.push('all')
        }
      }
      this.fetchFoundCourse()
    },
    onChangeRating() {
      this.fetchFoundCourse()
    },
    onChangeSort() {
      this.fetchFoundCourse()
    },
    async fetchFoundCourse() {
      try {
        const sort = {}
        // if (this.filter.type.includes('all')) this.filter.type = this.courseType.map(type => type.value)
        // sort
        if (this.sortBy === 'terbaru') sort.createdAt = -1
        else if (this.sortBy === 'terlama') sort.createdAt = 1
        else if (this.sortBy === 'termurah') sort.price = 1
        else if (this.sortBy === 'termahal') sort.price = -1
        //

        const { hash } = this.$route
        // this.$router.push({ name: 'Temukan', query: { sort: this.sortBy, type: query.type } }).catch(() => {})
        // type
        const types = []
        this.filter.type.forEach(type => {
          if (type === 'premium') types.push('premium')
          else if (type === 'free') types.push('free')
          else if (type === 'popular') types.push('popular')
        })

        // console.log(types, this.filter.type, 'fetch')
        //
        const { data: datas, totalCourse } = await this.$store.dispatch('course/FETCH_EXPLORE_COURSE_FILTERED', {
          sort,
          filters: {
            type: types,
            name: this.filter.search,
            rating: this.filter.starRating,
            category: this.filter.category,
          },
          page: { current: this.currentPage, limit: this.limitPerPage },
        })

        this.totalCourse = totalCourse

        const queryRouting = {
          sort: this.sortBy,
          type: this.filter.type.length === this.courseType.length ? ['all'] : types,
          rating: this.filter.starRating.length === 5 ? ['all'] : this.filter.starRating,
          category: this.filter.category.length === this.categoryOptions.length ? 'all' : this.filter.category,
        }

        if (this.filter.search) queryRouting.name = this.filter.search

        this.$router.replace({
          name: 'Temukan',
          query: queryRouting,
          hash,
        }).catch(() => {})
        // console.log(datas, 'found')
        this.foundCourseDatas = datas.map(data => {
          // console.log(data)
          return {
            ...data,
            key: data._id,
            title: data.name,
            instructor: data.vendor ? data.vendor.firstName + ' ' + data.vendor.lastName : '-',
            price: data.price,
            type: data.type,
            rating: data.averageRating,
            isWishlist: data.isWishlist,
            reviews: data.countReviews || 0,
          }
        })

        return new Promise((resolve, reject) => {
          resolve(true)
        })
      } catch (err) {
        console.log(err)
      }
    },
    async fetchFeaturedCourse() {
      try {
        const { data } = await this.$store.dispatch('course/FETCH_FEATURED_COURSE_DASHBOARD')
        // console.log(data, 'vendor')
        this.dataFeaturedCourses = data.map(course => {
          return {
            ...course,
            key: course._id,
            title: course.name,
            instructor: course.vendorId ? course.vendorId.firstName + ' ' + course.vendorId.lastName : '-',
            rating: course.averageRating,
            price: course.price,
            type: course.type,
            reviews: course.countReviews,
          }
        })
      } catch (err) {
        console.log(err)
      }
    },
    goTo(routeName, params = {}) {
      this.$router.push({ name: routeName, params })
    },
    async fetchCategory() {
      try {
        const data = await this.$store.dispatch('category/FETCH_CATEGORY')
        this.categoryOptions = data.map(data => {
          return {
            value: data.name,
            label: data.name,
          }
        })
        return new Promise((resolve, reject) => {
          resolve(true)
        })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
  },
  computed: {
    totalShownCourse() { return this.foundCourseDatas.length },
    searchCourse() { return this.$store.state.searchCourse },
  },
  async mounted() {
    try {
      this.fetchFeaturedCourse()
      await this.fetchCategory()

      const { query, hash } = this.$route
      if (Array.isArray(query.type)) {
        console.log(query.type, 'create')
        this.filter.type = query.type
      } else if (query.filter) {
        this.filter.type = this.filter.type.concat([query.type])
      } else {
        this.filter.type = ['all']
      }

      if (Array.isArray(query.rating)) {
        this.filter.starRating = query.rating.map(rating => Number(rating))
      } else if (query.rating && query.rating !== 'all') {
        this.filter.starRating = this.filter.starRating.concat([Number(query.rating)])
      }

      if (Array.isArray(query.category)) {
        this.filter.category = query.category
      } else if (query.category === 'all') {
        this.filter.category = this.categoryOptions.map(cat => cat.value)
      } else if (query.category) {
        this.filter.category = this.filter.category.concat([query.category])
      } else {
        this.filter.category = this.categoryOptions.map(cat => cat.value)
      }

      if (query.name) {
        this.filter.search = query.name
      }
      // console.log(query.rating, this.filter.starRating, Array.isArray(query.rating))
      await this.fetchFoundCourse()
      if (hash) {
        location.href = this.$route.hash
      }
    } catch (err) {
      console.log(err)
    }
  },
}
</script>

<style lang="scss">
@import "@/components/Kit/utils.scss";
.find-course-container {
  // .left-responsive {
  //   @apply w-full lg:w-1/5 !important;
  // }

  .th-button-select-group {
    .va-btn-text-fade > span {
      max-width: 100%;
      .va-trans-group-flex {
        flex-wrap: wrap;
        .va-selected-tag {
          margin: 3px;
        }
      }
    }
  }

  .shadow-box {
    box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.1);
  }

  .box-filter {
    padding: 16px 0px 20px;
  }

  .padding-x-content {
    padding: 0 16px;
    .search-input {
      z-index: 9;
    }
    .search-click {
      background-color: #3e4095;
      border-radius: 0px 4px 4px 0px;
      padding: 6px 7px;
      margin-left: -2px;
      z-index: 10;
      display: flex;
    }
  }

  .slick-dots {
    text-align: left !important;
    li {
      width: 19px !important;
      &.slick-active {
        button::before {
          color: #3e4095;
          opacity: 1;
        }
      }
      width: 10px;
      button {
        width: 30px;
        &::before {
          font-size: 10px;
          color: #f2f2f2;
          opacity: 1;
        }
        &:hover,
        &:focus {
          &::before {
            color: #3e4095;
            opacity: 1;
          }
          // color: #3E4095;
          // opacity: 1;
        }
      }
    }
  }

  .th-btn-sort {
    button {
      border: 1.4px solid $border;
      color: $black;
      background-color: $white;
    }

    .va-select-btn-open {
      background-color: $primary !important;
      .va-btn-text-fade .va-single-flex-wrap {
        color: $white !important;
      }

      i {
        color: $white !important;
      }

      &.va-btn-default:active:not(.va-btn-disabled) {
        background-color: $primary !important;
      }
    }
  }
}
</style>
